import React from "react";
import { Form, Header } from "semantic-ui-react";
import Metadata from "../Metadata";
import RichTextEditor from "../../RichTextEditor";

const details = ({ obj, language, onChange }) => {
  return (
    <div>
      <Header as="h3">Bloc contenu de la page passeport fidelite ({language.language})</Header>
      <Form.Field>
        <Form.Input label="Titre" placeholder="Titre" id="title" value={obj.translations[language.code].title} onChange={(e) => onChange(e, language.code)} />
        <Form.Field>
          <label>Description</label>
          <RichTextEditor id="description" value={obj.translations[language.code].description} onChange={(e) => onChange(e, language.code)} />
        </Form.Field>
        <Form.Field>
          <label>Contenu de l'email</label>
          <RichTextEditor id="email_content" value={obj.translations[language.code].email_content} onChange={(e) => onChange(e, language.code)} />
        </Form.Field>
      </Form.Field>
      <Metadata obj={obj} language={language} onChange={onChange} />
    </div>
  );
};

export default details;



// WEBPACK FOOTER //
// ./src/components/form/passportfidelite/details.js